import { render, staticRenderFns } from "./ResourceDropdown.vue?vue&type=template&id=0a3bc732&scoped=true&"
import script from "./ResourceDropdown.vue?vue&type=script&lang=js&"
export * from "./ResourceDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ResourceDropdown.vue?vue&type=style&index=0&id=0a3bc732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3bc732",
  null
  
)

export default component.exports